let visitorSessionRequest = null;

export async function ensureSearchVisitorSession() {
  if (!visitorSessionRequest) {
    visitorSessionRequest = fetch("/api/search/visitor-session", {
      method: "POST",
      credentials: "same-origin",
    }).then(async (response) => {
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(
          data.error || "Could not establish a search session",
        );
      }
      return true;
    }).catch((error) => {
      visitorSessionRequest = null;
      console.error("Search visitor session setup failed:", error);
      return false;
    });
  }
  return visitorSessionRequest;
}

export function readExternalSearchCooldown(data) {
  if (
    data?.error !== "EXTERNAL_SEARCH_COOLDOWN" ||
    !Number.isFinite(data.cooldown?.retryAfterSeconds) ||
    typeof data.cooldown?.retryAt !== "string"
  ) {
    return null;
  }
  return {
    retryAt: data.cooldown.retryAt,
    retryAfterSeconds: data.cooldown.retryAfterSeconds,
    requiresSignIn: data.cooldown.requiresSignIn === true,
  };
}
